import "@fortawesome/fontawesome-free/css/all.min.css";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import React from "react";
import { motion } from "framer-motion";
import { Card, Container } from "react-bootstrap";
import "./AboutMe.css";
import "bootstrap/dist/css/bootstrap.min.css";
import WebDevImg from "./ui/WebDevImg";
import UiUxImg from "./ui/uiux";
import { FaJava, FaNode } from "react-icons/fa";
import {
  SiHtml5,
  SiCss3,
  SiBootstrap,
  SiJavascript,
  SiReact,
  SiAngular,
  SiNpm,
  SiSap,
  SiAdobexd,
  SiFigma,
  SiIonic,
  SiPython,
  SiMysql,
} from "react-icons/si";
import BackEndImg from "./ui/BackEndImg";

const webdev = {
  title: "Web & Mobile Developer",
  fileName: "webdev",

  skills: [
    "Responsive web development using HTML5, CSS3, Bootstrap5, ReactJS, and Angular",
    "Robust backend development using Java, implementing efficient algorithms and data structures",
    "Database design and management with SQL, ensuring well-structured and optimized data models",
    "Experience in deploying and maintaining applications on SAP Cloud Platform, AWS EC2, Vercel, and Heroku",
  ],
};
const uiux = {
  title: "UI/UX Design",
  fileName: "uiux",
  skills: [
    "Expertise in crafting highly attractive user interfaces for mobile and web applications",
    "Creating the flow of application functionalities to optimize user experience",
    "Applying cutting-edge design principles and leveraging extensive wireframing expertise",
  ],
};
const backend = {
  title: "Back End Developer",
  fileName: "backend",
  skills: [
    "Proficient in creating RESTful APIs using Java, focusing on scalable and maintainable code architecture",
    "Experienced in performing comprehensive CRUD (Create, Read, Update, Delete) operations, ensuring efficient data manipulation and retrieval",
    "Expertise in database connectivity and operations, emphasizing secure and optimized data access.",
    "In-depth knowledge of server management and deployment, ensuring robust and continuous backend services",
  ],
};
function GetSkillSvg(props) {
  if (props.fileName === "webdev") return <WebDevImg theme={props.theme} />;
  else if (props.fileName === "uiux") return <UiUxImg theme={props.theme} />;
  else if (props.fileName === "backend") return <BackEndImg />;
}
const About = () => {
  const animationVariantsLeft = {
    initial: {
      opacity: 0,
      x: -100, // Start the content from outside the screen on the right side
    },
    animate: {
      opacity: 1,
      x: 0, // Move the content back to its original position
      transition: {
        duration: 1.5, // Adjust the duration as needed
        ease: "easeInOut", // Apply easing function for smoother animation
      },
    },
  };
  const animationVariantsRight = {
    initial: {
      opacity: 0,
      x: "100%", // Start the content from outside the screen on the right side
    },
    animate: {
      opacity: 1,
      x: 0, // Move the content back to its original position
      transition: {
        duration: 1.5, // Adjust the duration as needed
        ease: "easeInOut", // Apply easing function for smoother animation
      },
    },
  };
  return (
    <Container className="About-content">
      <div className="basic-projects">
        <div className="projects-heading-div">
          <div className="projects-heading-img-div">
            <div className="cardDiv">
              <Card className="about-card AboutMeCard">
                <Card.Body>
                  {/* <h2 className="card-title"> About Me</h2> */}

                  <p className="card-text">
                    Have strong foundation in designing and development of web
                    applications using technologies like HTML,JS,CSS. Looking
                    forward to working with a team of highly motivated people in
                    order to contribute and grow together. &nbsp;
                    <span className="white">
                      I have worked as an Associate Software Engineer at Incture
                      Technologies Pvt. Ltd, where I developed cutting-edge web
                      applications using frameworks.
                    </span>
                  </p>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="projects-heading-text-div">
            <h1 className="projects-heading-text">About Me</h1>

            {/* <p className="projects-header-detail-text subTitle">description</p> */}
          </div>
        </div>
      </div>

      <div>
        <div className="skills-main-div">
          <motion.p
            initial="initial"
            animate="animate"
            variants={animationVariantsLeft}
          >
            <div className="skills-image-div">
              {/* <img alt="" src={webdev} className="sdePic" /> */}
              <GetSkillSvg fileName={webdev.fileName} />
              {/* <WebDevImg /> */}
            </div>
          </motion.p>

          <div className="skills-text-div">
            <motion.p
              initial="initial"
              animate="animate"
              variants={animationVariantsRight}
            >
              <h1 className="skills-heading">{webdev.title}</h1>
            </motion.p>
            <motion.p
              initial="initial"
              animate="animate"
              variants={animationVariantsRight}
            >
              <div>
                {webdev.skills.map((skillSentence) => {
                  return (
                    <p className="subTitle skills-text">{skillSentence}</p>
                  );
                })}
              </div>
            </motion.p>
            <motion.p
              initial="initial"
              animate="animate"
              variants={animationVariantsRight}
            >
              <div className="skills-icons-div logoHbox">
                <OverlayTrigger
                  key="HTML"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>HTML</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiHtml5
                      className="iconSize"
                      style={{ color: "#E34F26" }}
                    />
                  </div>
                </OverlayTrigger>

                <OverlayTrigger
                  key="CSS3"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>CSS3</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiCss3 className="iconSize" style={{ color: "#1572B6" }} />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  key="JS"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>JavaScript</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiJavascript
                      className="iconSize"
                      style={{
                        backgroundColor: "#000000",
                        color: "#F7DF1E",
                      }}
                    />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  key="React"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>React</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiReact
                      className="iconSize"
                      style={{ color: "#61DAFB" }}
                    />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  key="Angular"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>Angular</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiAngular
                      className="iconSize"
                      style={{ color: "#c3002f" }}
                    />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  key="BootStrap"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>BootStrap</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiBootstrap
                      className="iconSize"
                      style={{ color: "#CC6699" }}
                    />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  key="NPM"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>NPM</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiNpm className="iconSize" style={{ color: "#CB3837" }} />
                  </div>
                </OverlayTrigger>

                <OverlayTrigger
                  key="SAP Fiori"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>SAP Fiori</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiSap className="iconSize" style={{ color: "#ffffff" }} />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  key="Ionic"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>Ionic</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiIonic
                      className="iconSize"
                      style={{ color: "#E34F26" }}
                    />
                  </div>
                </OverlayTrigger>
              </div>
            </motion.p>
          </div>
        </div>
        <div className="skills-main-div">
          <div className="skills-text-div">
            <motion.p
              initial="initial"
              animate="animate"
              variants={animationVariantsLeft}
            >
              <h1 className="skills-heading">{uiux.title}</h1>
            </motion.p>
            <motion.p
              initial="initial"
              animate="animate"
              variants={animationVariantsLeft}
            >
              <div>
                {uiux.skills.map((skillSentence) => {
                  return (
                    <p className="subTitle skills-text">{skillSentence}</p>
                  );
                })}
              </div>
            </motion.p>
            <motion.p
              initial="initial"
              animate="animate"
              variants={animationVariantsLeft}
            >
              <div className="skills-icons-div logoHbox">
                <OverlayTrigger
                  key="Figma"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>Figma</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiFigma
                      className="iconSize"
                      style={{ color: "#E34F26" }}
                    />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  key="AdobeXD"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>Adobe XD</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiAdobexd
                      className="iconSize"
                      style={{ color: "#844cb0" }}
                    />
                  </div>
                </OverlayTrigger>
              </div>
            </motion.p>
          </div>
          <motion.p
            initial="initial"
            animate="animate"
            variants={animationVariantsRight}
          >
            <div className="skills-image-div">
              <GetSkillSvg fileName={uiux.fileName} />
              {/* <WebDevImg /> */}
            </div>
          </motion.p>
        </div>
        <div className="skills-main-div">
          <motion.p
            initial="initial"
            animate="animate"
            variants={animationVariantsLeft}
          >
            <div className="skills-image-div">
              <GetSkillSvg fileName={backend.fileName} />
            </div>
          </motion.p>
          <div className="skills-text-div">
            <motion.p
              initial="initial"
              animate="animate"
              variants={animationVariantsRight}
            >
              <h1 className="skills-heading">{backend.title}</h1>
            </motion.p>
            <motion.p
              initial="initial"
              animate="animate"
              variants={animationVariantsRight}
            >
              <div>
                {backend.skills.map((skillSentence) => {
                  return (
                    <p className="subTitle skills-text">{skillSentence}</p>
                  );
                })}
              </div>
            </motion.p>
            <motion.p
              initial="initial"
              animate="animate"
              variants={animationVariantsRight}
            >
              <div className="skills-icons-div logoHbox">
                <OverlayTrigger
                  key="Java"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>Java</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <FaJava className="iconSize" style={{ color: "#5382a1" }} />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  key="Python"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>Python</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiPython
                      className="iconSize"
                      style={{ color: "#FFE873" }}
                    />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  key="NodeJS"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>NodeJS</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <FaNode className="iconSize" style={{ color: "#3C873A" }} />
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  key="MySQL"
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">
                      <strong>MySQL</strong>
                    </Tooltip>
                  }
                  rootClose
                >
                  <div>
                    <SiMysql
                      className="iconSize"
                      style={{ color: "#00758F" }}
                    />
                  </div>
                </OverlayTrigger>
              </div>
            </motion.p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default About;
